import { InsuranceBookedStyle } from "./InsuranceBooked.style";

const InsuranceBookedShimmer = () => {
  return <InsuranceBookedStyle></InsuranceBookedStyle>;
};

export default InsuranceBookedShimmer;
